export default class Environment {
    static get current() {
        return import.meta.env.VITE_APP_ENV;
    };

    static get database() {
        return import.meta.env.VITE_APP_DATABASE;
    };

    static get client() {
        return import.meta.env.VITE_APP_CLIENT;
    };
}